/**
 * Description placeholder
 *
 * @param {string} whatsAppNumber
 * @returns {string}
 */
const getWhatsAppLink = (whatsAppNumber) =>
  `https://api.whatsapp.com/send?phone=${whatsAppNumber}`;

export default getWhatsAppLink;
